import { Landmark } from "lucide-react";
import { can } from "@/features/auth/types";
import type { WidgetDef } from "../types";
import { RateGlance, RateView } from "./RateWidget";

export const rateWidget: WidgetDef<Record<string, never>> = {
  type: "rate",
  icon: Landmark,
  title: "rate.title",
  description: "rate.description",
  sizes: ["s", "m"],
  defaultSize: "s",
  defaultConfig: () => ({}),
  parseConfig: () => ({}),
  available: (me) => me.role === "owner" || (me.role === "branch_manager" && can(me, "budget")),
  View: RateView,
  Glance: RateGlance,
};
